/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import moment from "moment/moment";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import GohonzonHandoverModal from "../../../components/GohonzonHandoverModal/GohonzonHandoverModal";
import { getTableContent } from "../../../components/GohonzonTables";
import GohonzonSubHeading from "../../../components/GohozonSubHeading/GohonzonSubHeading";
import OTPVerification from "../../../components/OTPVerification/OTPVerification";
import RejectGohonzonApplication from "../../../components/RejectGohononApplication/RejectGohonzonApplication";
import SubmitButton from "../../../components/common/Button";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import CustomTable from "../../../components/common/new/Table/Table";
import {
  AlertStatus,
  Constants,
  GOHONZON_TYPE_OPTIONS,
  OTP_LEN,
} from "../../../contants";
import { GOHONZON_TABLES_MAP } from "../../../contants/gohonzon";
import {
  GET_ALL_APPLICATIONS_BY_BATCH,
  GET_ALL_GOHONZON_APPLICATIONS_BATCHES,
  GET_ALL_HANDOVER_APPLICATIONS,
  INITIATE_GOHONZON_APPLICATIONS,
  INITIATE_GOHONZON_TRACKING,
  SEARCH_MEMBERS_FOR_APPLY_GOHONZON,
  SEARCH_MEMBERS_FOR_RETURN_GOHONZON,
  SET_GOHONZON_TYPE_FOR_APPLY,
  SET_MEMBER_FOR_APPLY_GOHONZON,
  SET_RESET_GOHONZON_STATE,
} from "../../../redux/actionTypes/dashboard";
import {
  gohonzonLoading,
  selectGohonzonType,
  selectMembersForGohonzonApply,
  selectPaginationInfo,
} from "../../../redux/selectors/gohonzon";
import { performOperation } from "../../member/MemberSearch/utils";

import CancelGohonzonApplicationModal from "../../../components/CancelGohonzonApplicationModal/CancelGohonzonApplicationModal";
import GohonzonCancelRequestModal from "../../../components/GohonzonCancelRequestModal/GohonzonCancelRequestModal";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import {
  selectAllSIUsers,
  selectOSIdByUserRole,
  selectOSNamesByUserRole,
  selectUserProfile,
} from "../../../redux/selectors/user";
import Gohonzon from "../../../services/api/gohonzon";
import { isInteger } from "../../../utils";
import { ROUTES } from "../../../utils/constants";
import { createArrayByLen } from "../../../utils/helper";
import style from "./ApplyGohonzon.styles";
import Loader from "../../../components/common/Loader/Loader";
import GohonzonTracking from "../GohonzonTracking/GohonzonTracking";

const BATCH_SCREENS = [
  GOHONZON_TABLES_MAP.GOHONZON_BATCH_ALLOTMENT,
  GOHONZON_TABLES_MAP.GOHONZON_BATCH_HISTORY,
  GOHONZON_TABLES_MAP.ALLOTMENT_HISTORY,
  GOHONZON_TABLES_MAP.GOHONZON_BATCH_CONFERRAL,
  GOHONZON_TABLES_MAP.GOHONZON_VERIFICATION,
  GOHONZON_TABLES_MAP.GOHONZON_HANDOVER,
  GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION,
  GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST,
  GOHONZON_TABLES_MAP.GOHONZON_TRACKING,
];

const isBatchScreen = (type) => {
  return BATCH_SCREENS.includes(type);
};

function ApplyGohonzon({ type }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openHandoverModal, setOpenHandoverModal] = useState(false);
  const [openCancelRequestModal, setOpenCancelRequestModal] = useState(false);
  const [openCancelApplicationModal, setOpenCancelApplicationModal] =
    useState(false);
  const toast = useContext(ToastAlertContext);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const userOS = useSelector(selectOSIdByUserRole);
  const userProfile = useSelector(selectUserProfile);
  const userOSNames = useSelector(selectOSNamesByUserRole);
  const navigate = useNavigate();
  const memberList = useSelector(selectMembersForGohonzonApply);
  const paginationInfo = useSelector(selectPaginationInfo);
  const gohonzonType = useSelector(selectGohonzonType);
  const {
    isDistrictSi,
    isHelpDesk,
    isRegionSi,
    isHelpDeskAdmin,
    isNationalSi,
  } = useSelector(selectAllSIUsers);
  const dispatch = useDispatch();
  const { batchId } = useParams();
  const isLoading = useSelector(gohonzonLoading);
  const [openAddMemberModal, setOpenAddMemberModal] = useState(false);
  const [searchMemberId, setSearchMemberId] = useState("");
  const [searchedMember, setSearchedMember] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  const searchMemberById = async () => {
    if (!searchMemberId) {
      toast.show("Please enter Member ID", AlertStatus.ERROR);
      return;
    }

    try {
      setIsSearching(true);
      const { data } = await Gohonzon.searchMemberById(searchMemberId);
      const member = data?.content?.[0]; // ✅ yahi actual member hai

      if (!member) {
        toast.show("Member not found", AlertStatus.ERROR);
        return;
      }

      setSearchedMember(member);
    } catch (error) {
      toast.show("Member not found", AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsSearching(false);
    }
  };

  console.log("loadin", isLoading);

  console.log("USER: ", userProfile);
  const closeRejectModal = () => {
    setOpenRejectModal(false);
  };

  const closeHandoverModal = () => {
    setOpenHandoverModal(false);
  };

  const closeCancelRequestModal = () => {
    setOpenCancelRequestModal(false);
  };

  const closeCancelApplicationModal = () => {
    setOpenCancelApplicationModal(false);
  };

  const getStatus = () => {
    switch (type) {
      case GOHONZON_TABLES_MAP.GOHONZON_APPLICATIONS:
        return "INITIATED";
      case GOHONZON_TABLES_MAP.GOHONZON_INTERVIEW:
        return "VERIFIED";
      case GOHONZON_TABLES_MAP.GOHONZON_VERIFICATION:
        return "INTERVIEWED";
      case GOHONZON_TABLES_MAP.GOHONZON_BATCH_ALLOTMENT:
        return "CREATED";
      case GOHONZON_TABLES_MAP.ALLOTMENT_HISTORY:
      case GOHONZON_TABLES_MAP.GOHONZON_BATCH_VIEW:
        return "";
      case GOHONZON_TABLES_MAP.GOHONZON_HANDOVER:
        return "PROCESSED";
      case GOHONZON_TABLES_MAP.GOHONZON_BATCH_CONFERRAL:
        return "HANDOVER";
      //  case GOHONZON_TABLES_MAP.GOHONZON_VERIFICATION:
      //     return "INTERVIEWED";
      case GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER:
        return "RETURN_REQUESTED";
      case GOHONZON_TABLES_MAP.GOHONZON_RETURN_REQUEST:
        return "";
      case GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION:
      case GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_VERIFICATION:
        return "RETURN_INITIATED";
      case GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST:
        return "ALLOTMENT_CANCELLATION_REQUESTED";
      case GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_ALLOTMENT:
        return "FINAL_INTERVIEWED";
      case GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_HANDOVER:
        return "ALLOTTED";
      case GOHONZON_TABLES_MAP.GOHONZON_BATCH_HISTORY:
      case GOHONZON_TABLES_MAP.GOHONZON_TRACKING:
        return "";
      case GOHONZON_TABLES_MAP.GOHONZON_APPROVAL:
        return "INTERVIEWED";
      case GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_CONFERRAL:
        return "APPLICATION_HANDOVER";
      case GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_CONFERRAL:
        return "APPLICATION_HANDOVER";
      default:
        return "DRAFT";
    }
  };
  const getFormType = () => {
    switch (type) {
      case GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION:
      case GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER:
      case GOHONZON_TABLES_MAP.GOHONZON_TRACKING:
        return "";
      case GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_CONFERRAL:
      case GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_VERIFICATION:
        return "REPLACEMENT";
      default:
        return "APPLICATION";
    }
  };

  const getTypeParams = () => {
    switch (type) {
      case GOHONZON_TABLES_MAP.GOHONZON_BATCH_HISTORY:
        return "createdByMe";
      case GOHONZON_TABLES_MAP.ALLOTMENT_HISTORY:
        return "allottedByMe";
      default:
        return "";
    }
  };

  const getGohonzonType = () => {
    switch (type) {
      case GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST:
      case GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_CONFERRAL:
      case GOHONZON_TABLES_MAP.GOHONZON_APPLICATIONS:
      case GOHONZON_TABLES_MAP.GOHONZON_INTERVIEW:
      case GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER:
      case GOHONZON_TABLES_MAP.GOHONZON_RETURN_REQUEST:
      case GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION:
      case GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_VERIFICATION:
      case GOHONZON_TABLES_MAP.ALLOTMENT_HISTORY:
      case GOHONZON_TABLES_MAP.GOHONZON_TRACKING:
        return "";
      case GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_ALLOTMENT:
      case GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_HANDOVER:
      case GOHONZON_TABLES_MAP.GOHONZON_APPROVAL:
      case GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_CONFERRAL:
        return "OMAMORI_GOHONZON";
      default:
        return "OKATAKI_GOHONZON";
    }
  };

  const getDispatchType = () => {
    if (isDistrictSi) return SEARCH_MEMBERS_FOR_APPLY_GOHONZON;
    if (type === GOHONZON_TABLES_MAP.GOHONZON_RETURN_REQUEST)
      return SEARCH_MEMBERS_FOR_RETURN_GOHONZON;
    if (
      type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_ALLOTMENT ||
      type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_HISTORY ||
      type === GOHONZON_TABLES_MAP.GOHONZON_HANDOVER
    )
      return GET_ALL_GOHONZON_APPLICATIONS_BATCHES;
    if (type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_CONFERRAL)
      return GET_ALL_HANDOVER_APPLICATIONS;
    if (
      type === GOHONZON_TABLES_MAP.GOHONZON_ALLOTMENT ||
      type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_VIEW ||
      type === GOHONZON_TABLES_MAP.GOHONZON_CONFERRAL
    )
      return GET_ALL_APPLICATIONS_BY_BATCH;

    if (type === GOHONZON_TABLES_MAP.GOHONZON_TRACKING)
      return INITIATE_GOHONZON_TRACKING;
    return INITIATE_GOHONZON_APPLICATIONS;
  };

  const onSearchClick = async (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    dispatch({
      type: getDispatchType(),
      payload: {
        memberName: isInteger(searchQuery) ? "" : searchQuery,
        memberId:
          searchQuery && isInteger(searchQuery) ? Number(searchQuery) : "",
        page: pageNumber,
        size: pageSize,
        status: getStatus(),
        type: getTypeParams(),
        gohonzonType: getGohonzonType(),
        formType: getFormType(),
        ...(isDistrictSi ? userOS : {}),
        ...(isRegionSi ? userOS : {}),
        ...(batchId ? { batchId } : {}),
      },
    });
  };

  const refreshList = () => {
    onSearchClick();
  };

  const addMemberInBatch = async () => {
    console.log("searchedMember.id", searchedMember.memberId);
    try {
      await Gohonzon.addMemberInBatch({
        batchId,
        memberId: searchedMember.memberId,
      });

      toast.show("Member added in batch successfully", AlertStatus.SUCCESS);
      setOpenAddMemberModal(false);
      setSearchedMember(null);
      onSearchClick(); // refresh list
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const submitInterView = async (application) => {
    try {
      await Gohonzon.submitInterViewByRegionSi(
        {
          formType: "APPLICATION",
          memberId: application.memberId,
          gohonzonType: application.gohonzonType,
        },
        application.id
      );
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        onSearchClick();
      }, 1000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    }
  };

  const returnVerificationSubmit = async (application) => {
    try {
      await Gohonzon.GohonzonReturnVerification(
        {
          formType: "RETURN",
          memberId: application.memberId,
          gohonzonType: application.gohonzonType,
        },
        application.id,
        application.memberId
      );
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        refreshList(); // goBack();
      }, 2000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    }
  };

  const submitVerifiedApplication = async (otp) => {
    try {
      await Gohonzon.gohonzonOtpVerification(
        {
          formType: "APPLICATION",
          memberId: selectedApplication.memberId,
          gohonzonType: selectedApplication.gohonzonType,
          otp,
        },
        selectedApplication.id
      );
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setShowOtpModal(false);
      setTimeout(() => {
        onSearchClick();
      }, 1000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    }
  };

  const createBatchByRegionSi = async () => {
    if (selectedApplications.length) {
      try {
        await Gohonzon.createBatchByRegion({
          applicationIds: selectedApplications,
        });
        toast.show("Successfully Done", AlertStatus.SUCCESS);
        setTimeout(() => {
          onSearchClick();
        }, 1000);
      } catch (err) {
        toast.show(err.message, AlertStatus.ERROR);
        Sentry.captureException(err);
      }
    } else {
      toast.show("Please select applications", AlertStatus.ERROR);
    }
  };

  const allotApplication = async (application) => {
    try {
      await Gohonzon.allotApplication(
        {
          formType: "APPLICATION",
          memberId: application.memberId,
          gohonzonType: application.gohonzonType,
        },
        application.id
      );
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        refreshList();
      }, 1000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    }
  };

  const onPaginationClick = (page) => {
    const { pageSize } = paginationInfo;
    onSearchClick(page, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    onSearchClick(0, newPageSize);
  };

  const setGohonzonType = (e) => {
    dispatch({
      type: SET_GOHONZON_TYPE_FOR_APPLY,
      payload: e.target.value,
    });
  };

  const selectionHandler = (value, memberId) => {
    if (value) {
      setSelectedApplications((prev) => [...prev, memberId]);
    } else {
      setSelectedApplications((prev) => prev.filter((id) => id !== memberId));
    }
  };

  const checkAllToggle = (checked) => {
    if (checked && memberList.length) {
      setSelectedApplications(
        memberList
          .filter((member) => member.status !== "BATCH_CREATED")
          .map((member) => member.id)
      );
    } else {
      setSelectedApplications([]);
    }
  };

  const onMemberSelect = (selectedMember, params = "") => {
    dispatch({
      type: SET_MEMBER_FOR_APPLY_GOHONZON,
      payload: selectedMember,
    });
    navigate(`/${ROUTES.GOHOZON_SUBMISSION.path}${params ? `/${params}` : ""}`);
  };

  const onBatchSelect = (batchIdParam) => {
    navigate(`/${ROUTES.GOHONZON_ALLOTMENT.path}/${batchIdParam}`);
  };

  const onBatchView = (batchIdParam) => {
    navigate(`/${ROUTES.GOHONZON_BATCH_VIEW.path}/${batchIdParam}`);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onSearchClick();
  };

  const openOtpModal = (application) => {
    setSelectedApplication(application);
    setShowOtpModal(true);
  };

  const onHandoverApplication = (application) => {
    setSelectedApplication(application);
    setOpenHandoverModal(true);
  };

  const onBatchConferral = async (batch, conferralDate) => {
    try {
      await Gohonzon.batchConferral({
        id: batch.id,
        conferralDate: moment(moment(conferralDate)).format("YYYY-MM-DD"),
      });
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        refreshList();
      }, 1000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const onApplicationConferral = async (application, conferredDate) => {
    console.log(conferredDate);
    try {
      await Gohonzon.markIndividualConferral(
        {
          memberId: application.memberId,
          conferredDate: moment(moment(conferredDate)).format("YYYY-MM-DD"),
        },
        application.id
      );
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        refreshList();
      }, 1000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const onRejectApplication = (application) => {
    setSelectedApplication(application);
    setOpenRejectModal(true);
  };

  const onCancelRequestApplication = (application) => {
    setSelectedApplication(application);
    setOpenCancelRequestModal(true);
  };

  // const onCancelApplication = (application) => {
  //   setSelectedApplication(application);
  //   setOpenCancelApplicationModal(true);
  // };

  const onOtpSubmit = (e) => {
    e.preventDefault();
    const { elements } = e.target;
    const otpInString = createArrayByLen(OTP_LEN)
      .reduce((acc, _, index) => {
        return acc + (elements[`otp-${index + 1}`]?.value ?? "");
      }, "")
      ?.replace(/ /gi, "");

    if (otpInString.length < OTP_LEN) {
      toast.show("Please fill OTP first", AlertStatus.ERROR);
      return;
    }

    submitVerifiedApplication(Number(otpInString));
  };

  const openBatch = () => {
    navigate(`/${ROUTES.GOHONZON_ALLOTMENT.path}`);
  };

  const openConferralBatch = (batchIdParam) => {
    navigate(`/${ROUTES.GOHONZON_CONFERRAL.path}/${batchIdParam}`);
  };

  const fetchApplications = async (application) => {
    try {
      const { data } = await Gohonzon.getApplicationsByBatchId(
        null,
        application.id
      );
      return data?.content?.map((app) => app.id);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handoverSubmit = async (e, selectedMemberId) => {
    try {
      const { elements } = e.target;
      const otpInString = createArrayByLen(OTP_LEN)
        .reduce((acc, _, index) => {
          return acc + (elements[`otp-${index + 1}`]?.value ?? "");
        }, "")
        ?.replace(/ /gi, "");

      if (otpInString.length < OTP_LEN || !selectedMemberId) {
        toast.show("Please provide input", AlertStatus.ERROR);
        return;
      }

      if (type === GOHONZON_TABLES_MAP.GOHONZON_HANDOVER) {
        const applicationIds = await fetchApplications(selectedApplication);

        await Gohonzon.batchHandover({
          formType: "APPLICATION",
          otp: Number(otpInString),
          handoverTo: Number(selectedMemberId),
          id: selectedApplication.id,
          applicationIds,
        });
      } else if (type === GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER) {
        await Gohonzon.handoverAtHelpdesk(
          {
            formType: "RETURN",
            otp: Number(otpInString),
            returnBy: Number(selectedMemberId),
            id: selectedApplication.id,
          },
          selectedApplication.memberId,
          selectedApplication.id
        );
      } else if (type === GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST) {
        await Gohonzon.gohonzonHandoverCancelAllotmentRequest(
          {
            formType: "APPLICATION",
            otp: Number(otpInString),
            returnBy: Number(selectedMemberId),
            id: selectedApplication.id,
          },
          selectedApplication.memberId,
          selectedApplication.id
        );
      } else {
        await Gohonzon.applicationHandover({
          formType: "APPLICATION",
          otp: Number(otpInString),
          handoverTo: Number(selectedMemberId),
          id: selectedApplication.id,
          memberId: selectedApplication.memberId,
          gohonzonType: selectedApplication.gohonzonType,
        });
      }

      closeHandoverModal();
      toast.show("Successfully Done", AlertStatus.SUCCESS);

      setTimeout(() => {
        refreshList();
      }, 1000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const getHandoverTitle = () => {
    if (type === GOHONZON_TABLES_MAP.GOHONZON_HANDOVER) {
      return "Gohonzon Handover";
    }
    if (type === GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_HANDOVER) {
      return "Gohonzon Handover";
    }
    if (type === GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER) {
      return "Returned Gohonzon Handover";
    }
    if (type === GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST) {
      return "Gohonzon Cancellation Handover";
    }
  };

  // const getValue = (obj, path) => {
  //   return path.split(".").reduce((acc, part) => acc?.[part], obj) ?? "";
  // };

  const exportToCSV = () => {
    if (!memberList?.length) {
      toast.show("No data to export", AlertStatus.ERROR);
      return;
    }

    try {
      console.log("memberList data =>", memberList);

      const selectedFields = [
        { key: "sn", label: "S.N." },
        { key: "batch_id", label: "BatchNo" },
        { key: "regionApprovedAt", label: "BatchDT" },
        { key: "memberId", label: "Member_id" },
        { key: "memberDetails.fullName", label: "MemberName" },
        { key: "memberDetails.mobileNumber", label: "Mobile" },
        { key: "areaName", label: "Area" },
        { key: "zoneName", label: "Zone" },
        { key: "regionName", label: "Region" },
        { key: "chapterName", label: "Chapter" },
        { key: "districtName", label: "District" },
        { key: "memberDetails.positions", label: "Position" },
        { key: "memberDetails.divisionName", label: "Division" },
        // { key: "memberDetails.dateOfBirth", label: "Date Of Birth" },
        { key: "memberDetails.dateOfBirth", label: "Age", isAge: true },
        { key: "memberAnswers.1", label: "Yrs_Prac" },
        { key: "chapterAnswers.1", label: "CC_YP" },
        { key: "chapterAnswers.3", label: "CC_FP" },
        { key: "chapterAnswers.2", label: "CC_PE" },
        { key: "homeVisitedByName", label: "CC_Visted" },
      ];

      // ✅ Helper: Get Nested Value
      const getValue1 = (obj, path) => {
        if (!path) return "";
        return path.split(".").reduce((acc, key) => acc?.[key], obj);
      };

      // ✅ Helper: Calculate Age
      const calculateAge = (dob) => {
        if (!dob) return "NA";

        const birthDate = new Date(dob);
        if (Number.isNaN(birthDate.getTime())) return "NA";

        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age -= 1; // instead of age--
        }

        return age;
      };
      const getAnswer = (answersArray, questionId) => {
        if (!answersArray?.length) return "NA";
        const answerObj = answersArray.find((a) => a.questionId === questionId);
        return answerObj ? answerObj.answer : "NA";
      };

      // ✅ Headers
      const headers = selectedFields.map((f) => f.label).join(",");

      // ✅ Rows
      const rows = memberList.map((row, index) =>
        selectedFields
          .map((f) => {
            if (f.key === "sn") {
              return `"${index + 1}"`; // serial number starts from 1
            }

            if (f.key === "batch_id") {
              return `"${batchId ?? "NA"}"`;
            }

            if (f.key === "regionApprovedAt") {
              const dateValue = getValue1(row, f.key);
              if (!dateValue) return `"NA"`;
              const d = new Date(dateValue);
              const formattedDate = `${String(d.getDate()).padStart(
                2,
                "0"
              )}-${String(d.getMonth() + 1).padStart(
                2,
                "0"
              )}-${d.getFullYear()}`;
              return `"${formattedDate}"`;
            }
            if (f.isAge) {
              return `"${calculateAge(getValue1(row, f.key))}"`;
            }
            if (f.key?.startsWith("memberAnswers")) {
              const questionId = parseInt(f.key.split(".")[1], 10);
              return `"${getAnswer(row.memberAnswers, questionId)}"`;
            }
            if (f.key?.startsWith("chapterAnswers")) {
              const questionId = parseInt(f.key.split(".")[1], 10);
              return `"${getAnswer(row.chapterAnswers, questionId)}"`;
            }
            if (f.key === "memberDetails.positions") {
              const positions = getValue1(row, f.key) || [];
              if (!positions.length) return `"NA"`;

              const mainlineNames = positions
                .filter((p) => p.positionType === "MAINLINE_POSITION")
                .map((p) => p.name);

              return `"${
                mainlineNames.length ? mainlineNames.join("/") : "NA"
              }"`;
            }

            const value = getValue1(row, f.key);
            return `"${value ?? "NA"}"`;
          })
          .join(",")
      );

      const csvString = [headers, ...rows].join("\n");

      // ✅ Timestamp filename
      const now = new Date();
      const timestamp = `${now.getFullYear()}${String(
        now.getMonth() + 1
      ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}_${String(
        now.getHours()
      ).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}`;

      const fileName = `gohonzon_data_${timestamp}.csv`;

      // ✅ Blob create & download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.show("Failed to export CSV", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const content = useMemo(() => {
    return getTableContent(type);
  }, [type]);

  const getRows = () => {
    const TableComponent = content.component;
    return memberList.map((member) => {
      return (
        <TableComponent
          member={member}
          gohonzonType={gohonzonType}
          onMemberSelect={onMemberSelect}
          selectionHandler={selectionHandler}
          selectedApplications={selectedApplications}
          openBatch={openBatch}
          openConferralBatch={openConferralBatch}
          submitInterView={submitInterView}
          openOtpModal={openOtpModal}
          onBatchSelect={onBatchSelect}
          onBatchView={onBatchView}
          allotApplication={allotApplication}
          onRejectApplication={onRejectApplication}
          onHandoverApplication={onHandoverApplication}
          onBatchConferral={onBatchConferral}
          onApplicationConferral={onApplicationConferral}
          onCancelRequestApplication={onCancelRequestApplication}
          returnVerificationSubmit={returnVerificationSubmit}
        />
      );
    });
  };

  useEffect(() => {
    dispatch({
      type: SET_RESET_GOHONZON_STATE,
    });
    onSearchClick();
  }, [type, batchId]);

  return (
    <Box sx={style.container}>
      {!isBatchScreen(type) && (
        <form onSubmit={onSubmit}>
          <Box style={style.search}>
            {(type === GOHONZON_TABLES_MAP.GOHONZON_APPLY ||
              type === GOHONZON_TABLES_MAP.GOHONZON_RETURN_REQUEST) && (
              <Box width="40%">
                <Dropdown
                  value={gohonzonType}
                  options={GOHONZON_TYPE_OPTIONS}
                  label="Gohonzon Type"
                  onChange={setGohonzonType}
                />
              </Box>
            )}

            <Box width="40%">
              <InputField
                name="searchMember"
                label="Member Name/ID"
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Box>

            <Box width="15%">
              <SubmitButton
                label="SEARCH"
                type="submit"
                style={style.searchButton}
              />
            </Box>
          </Box>

          {/* <Box mt={2} width="40%">
            <SubmitButton
              label="EXPORT CSV"
              type="button"
              onClick={exportToCSV}
              style={{
                ...style.searchButton,
                backgroundColor: "#4caf50",
                width: 190,
              }}
            />
          </Box> */}

          {(isHelpDesk || isHelpDeskAdmin) && (
            <Box mt={2} display="flex" gap={2}>
              <SubmitButton
                label="ADD MEMBER"
                type="button"
                onClick={() => setOpenAddMemberModal(true)}
                style={{
                  ...style.searchButton,
                  backgroundColor: "#1976d2",
                  width: 192,
                }}
              />

              <SubmitButton
                label="EXPORT CSV"
                type="button"
                onClick={exportToCSV}
                style={{
                  ...style.searchButton,
                  backgroundColor: "#4caf50",
                  width: 190,
                }}
              />
            </Box>
            // <Box mt={2} width="40%">
            //   <SubmitButton
            //     label="EXPORT CSV"
            //     type="button"
            //     onClick={exportToCSV}
            //     style={{
            //       ...style.searchButton,
            //       backgroundColor: "#4caf50",
            //       width: 190,
            //     }}
            //   />
            // </Box>
          )}
        </form>
      )}
      {type === GOHONZON_TABLES_MAP.GOHONZON_TRACKING && (
        <>
          <Box mt="1rem" mb="2rem">
            <GohonzonSubHeading
              userOSNames={userOSNames}
              heading={content.subHeading}
              hideAction={type}
              hideOS={isHelpDesk || isHelpDeskAdmin || isNationalSi}
            />
          </Box>
          <GohonzonTracking
            onSubmit={onSubmit}
            type={type}
            onMemberSelect={onMemberSelect}
          />
        </>
      )}

      {memberList?.length && type !== GOHONZON_TABLES_MAP.GOHONZON_TRACKING ? (
        <Box mt="1rem" mb="2rem">
          <GohonzonSubHeading
            userOSNames={userOSNames}
            heading={content.subHeading}
            submitHandler={createBatchByRegionSi}
            hideOS={isHelpDesk || isHelpDeskAdmin || isNationalSi}
            hideAction={type !== GOHONZON_TABLES_MAP.GOHONZON_VERIFICATION}
          />
        </Box>
      ) : null}
      {memberList?.length && type !== GOHONZON_TABLES_MAP.GOHONZON_TRACKING ? (
        <Box style={style.tableContainer}>
          <Box style={style.customTable}>
            <CustomTable
              checkAllToggle={checkAllToggle}
              columnCellStyle={{ textAlign: "left" }}
              scrollable
              columns={content.colums}
              rows={getRows()}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
                // textAlign: "left",
              }}
            />
          </Box>
          <Box style={style.pagination}>
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        </Box>
      ) : (
        !isLoading && (
          <Box>
            {memberList.length === 0 ? (
              <Box style={style.emptyContainer}>
                {type !== GOHONZON_TABLES_MAP.GOHONZON_TRACKING && (
                  <h1 style={style.noDataMsg}>No Results</h1>
                )}
              </Box>
            ) : (
              !isBatchScreen(type) && (
                <span style={style.text}>Search to Apply</span>
              )
            )}
          </Box>
        )
      )}
      {isLoading && <Loader />}
      <OTPVerification
        visible={showOtpModal}
        onClose={() => setShowOtpModal(false)}
        onSubmit={onOtpSubmit}
      />
      <RejectGohonzonApplication
        open={openRejectModal}
        onClose={closeRejectModal}
        application={selectedApplication}
        refreshList={refreshList}
        toast={toast}
      />
      <GohonzonHandoverModal
        open={openHandoverModal}
        onClose={closeHandoverModal}
        application={selectedApplication}
        userProfile={userProfile}
        refreshList={refreshList}
        toast={toast}
        title={getHandoverTitle()}
        handleSubmit={handoverSubmit}
      />
      <GohonzonCancelRequestModal
        open={openCancelRequestModal}
        onClose={closeCancelRequestModal}
        application={selectedApplication}
        refreshList={refreshList}
        toast={toast}
      />
      <CancelGohonzonApplicationModal
        open={openCancelApplicationModal}
        onClose={closeCancelApplicationModal}
        application={selectedApplication}
        refreshList={refreshList}
        toast={toast}
      />
      <Dialog
        open={openAddMemberModal}
        onClose={() => setOpenAddMemberModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Member in Batch</DialogTitle>

        <DialogContent>
          <Box mt={2}>
            <InputField
              label="Member ID"
              type="number"
              value={searchMemberId}
              onChange={(e) => {
                const { value } = e.target;
                if (/^\d*$/.test(value)) {
                  setSearchMemberId(value);
                }
              }}
            />

            <Box mt={2}>
              <SubmitButton
                label="SEARCH"
                onClick={searchMemberById}
                disabled={isSearching}
              />
            </Box>

            {searchedMember && (
              <Box mt={3} p={2} border="1px solid #ddd" borderRadius={2}>
                <p>
                  <b>Name:</b> {searchedMember.fullName}
                </p>
                <p>
                  <b>Mobile:</b> {searchedMember.mobileNumber}
                </p>
                <p>
                  <b>District:</b> {searchedMember.districtName}
                </p>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <SubmitButton
            label="CANCEL"
            onClick={() => {
              setOpenAddMemberModal(false);
              setSearchMemberId("");
              setSearchedMember(null);
            }}
            style={{ backgroundColor: "#9e9e9e" }}
          />

          <SubmitButton
            label="ADD IN BATCH"
            onClick={addMemberInBatch}
            disabled={!searchedMember}
            style={{ backgroundColor: "#1976d2", width: 150 }}
          />
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ApplyGohonzon;
